<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                afflictionForm: () => import('../forms/AfflictionForm'),
                inspectionForm: () => import('../forms/InspectionForm'),
                fileForm: () => import('../forms/FileForm'),
                afflictionSightingFileForm: () => import('../forms/AfflictionSightingFileForm'),
                fields: [
                    { type: 'autocomplete', text: 'Inspection', value: 'inspectionId', rules: [v => !!v || 'Inspection is required'], isRequired: true, form: () => import('./InspectionForm'), apiMethod: 'Inspections', claim: 'Inspections' },
                    { type: 'autocomplete', text: 'Affliction', value: 'afflictionId', rules: [v => !!v || 'Affliction is required'], isRequired: true, form: () => import('./AfflictionForm'), apiMethod: 'Afflictions', claim: 'Afflictions' },
                    { type: 'number', text: 'Number Of Hives', value: 'numberOfHives', rules: [v => (v !== null && v !== '') || 'Number Of Hives is required'], isRequired: true },
                    { type: 'file', text: 'Inspection Record File', value: 'inspectionRecordFileId', rules: [], form: () => import('./FileForm'), apiMethod: 'Files' },
                    { type: 'files', text: 'Files', value: 'fileIds', parentColumnName: 'afflictionSightingId', form: () => import('../forms/AfflictionSightingFileForm') }
                ],
                apiMethod: 'AfflictionSightings',
                formTitle: 'Affliction Sighting',
            }
        },
    };
</script>
